module.exports = __webpack_public_path__ + "static/img/articles.fa2b2591.png";